
import style from "../RoundVideoResultFive/CSS/RoundVideoResult.module.css";
import Round from "../RoundVideoResultFive/Component/Round";
import Title from "../RoundVideoResultFive/Component/Title";
import SubTitle from "../RoundVideoResultFive/Component/SubTitle";
import Banner from "../RoundVideoResultFive/Component/Banner";
import Slider from "../RoundVideoResultFive/Component/Slider";
import Details from "../RoundVideoResultFive/Component/Details";
import Button from "../RoundVideoResultFive/Component/Button";
import Result from "./Component/Result";


import sliderOne from "../RoundVideoResultFive/img/sliderOne.png";
import sliderTwo from "../RoundVideoResultFive/img/sliderThree.png";
import sliderThree from "../RoundVideoResultFive/img/sliderTwo.png";
import sliderFour from "../RoundVideoResultFive/img/sliderOne.png";
import sliderFive from "../RoundVideoResultFive/img/sliderTwo.png";
import sliderSix from "../RoundVideoResultFive/img/sliderThree.png";
import coverPhoto from "../RoundVideoResultFive/img/banner.png";
import videoImage from "../RoundVideoResultFive/img/video.png";

import superStar1 from "../RoundVideoResultFive/img/superStar1.png";
import superStar2 from "../RoundVideoResultFive/img/superStar2.png";
import superStar3 from "../RoundVideoResultFive/img/superStar3.png";



const sliders = [
    {slider: sliderOne},
    {slider: sliderTwo},
    {slider: sliderThree},
    {slider: sliderFour},
    {slider: sliderFive},
    {slider: sliderSix},
];

const data = [
    {video:videoImage, star:54, user:52},
    {video:videoImage, star:34, user:84},
    {video:videoImage, star:35, user:45},
    {video:videoImage, star:78, user:45},
    {video:videoImage, star:75, user:65},
    {video:videoImage, star:25, user:75},
];

const resultTwo =[
    {
        userInfo: {
            name: 'User name',
            like: '24k',
            love: '200',
            mark: '66',
            image: videoImage,
        },
        comment:[
            { superStarName: 'habib wahid', superStarImage:superStar1},
            { superStarName: 'imran', superStarImage:superStar2},
            { superStarName: 'momtaz', superStarImage:superStar3},
        ],
        selectStatus: true
    },
]

const result = [
    {
        userInfo: {
            name: 'User name',
            like: '24k',
            love: '200',
            mark: '66',
            image: videoImage,
        },
        comment:[
            { superStarName: 'habib wahid', superStarImage:superStar1},
            { superStarName: 'imran', superStarImage:superStar2},
            { superStarName: 'momtaz', superStarImage:superStar3},
        ],
        selectStatus: true
    },
    {
        userInfo: {
            name: 'User name',
            like: '204k',
            love: '100',
            mark: '78',
            image: videoImage,
        },
        comment:[
            { superStarName: 'habib wahid', superStarImage:superStar1},
            { superStarName: 'imran', superStarImage:superStar2},
        ],
        selectStatus: false
    },
    {
        userInfo: {
            name: 'User name',
            like: '30k',
            love: '300',
            mark: '77',
            image: videoImage,
        },
        comment:[
            { superStarName: 'habib wahid', superStarImage:superStar1},
            { superStarName: 'momtaz', superStarImage:superStar3},
        ],
        selectStatus: false
    },
    {
        userInfo: {
            name: 'User name',
            like: '24k',
            love: '400',
            mark: '99',
            image: videoImage,
        },
        comment:[
            { superStarName: 'habib wahid', superStarImage:superStar1},
            { superStarName: 'imran', superStarImage:superStar2},
            { superStarName: 'momtaz', superStarImage:superStar3},
        ],
        selectStatus: true
    },
    {
        userInfo: {
            name: 'User name',
            like: '24k',
            love: '200',
            mark: '66',
            image: videoImage,
        },
        comment:[
            { superStarName: 'habib wahid', superStarImage:superStar1},
            { superStarName: 'imran', superStarImage:superStar2},
            { superStarName: 'momtaz', superStarImage:superStar3},
        ],
        selectStatus: false
    },
]

const RoundVideoResultFive = () => {
    return (
        <>
            <div className={style.section}>
                <Round round={'01'} status={'done'}/>
                <Round round={'02'} status={'done'}/>
                <Round round={'03'} status={'done'}/>
                <Round round={'04'} status={'done'}/>
                <Round round={'05'} status={'done'}/>
                <Round round={'06'} status={'done'}/>
                <Round round={'07'} status={'running'}/>
                <Round round={'08'} status={'pending'}/>
            </div>

            <div>
                <Title title={'round status'}/>
            </div>

            <div>
                <SubTitle subTitle={'submitted content'}/>
            </div>

            <div>
                <Banner title={'1st round time duration june 25 - july 30'} coverPhoto={coverPhoto}/>
            </div>

            <div>
                <Title title={'audition round-7'}/>
            </div>

            <div>
                <SubTitle subTitle={'total video - 75'}/>
            </div>

            <div>
                <Slider sliders={sliders}/>
            </div>

            <div>
                <Title title={'round7 - 30 user quality for the next round'}/>
            </div>

            <div>
                <Details data={data}/>
            </div>

            <div>
                <Title title={'guitar for the beginners - round7 - oxygen video feed result'}/>
            </div>

            <div>
                <Result data={result}/>
            </div>

            <div style={{margin: '40px 0px 30px', textAlign: 'center'}}>
                <Button text={'merge all the video'}/>
            </div>

        </>
    );
};

export default RoundVideoResultFive;